// Format monétaire selon la langue : 276,80 $ (fr) / $276.80 (en)
export const fmtPrice = (v, lang = "fr") =>
  lang === "en"
    ? `$${Number(v).toFixed(2)}`
    : `${Number(v).toFixed(2).replace(".", ",")} $`;
